import React, { useState } from 'react';
import FlagIcon from '../components/FlagIcon';

const MAX_CAPACITY = 90000;

const STADIUMS = [
  // ── Mexico ───────────────────────────────────────────────────────────────
  {
    name: 'Estadio Azteca',
    city: 'Mexico City', country: 'Mexico', code: 'mx',
    capacity: 87600, role: 'Opening Match', roleTier: 'special',
    img: 'https://upload.wikimedia.org/wikipedia/commons/4/4b/Estadio_Azteca_y_sus_alrededores_46.jpg',
    description: 'The only stadium to host three FIFA World Cups (1970, 1986, 2026) and two World Cup Finals. When the opening whistle blows here on June 11, history will be made for the third time.',
    fact: 'In 1986, Diego Maradona scored both the "Hand of God" goal and the "Goal of the Century" here in the same match against England.',
    matches: [
      { date: 'Jun 11', round: 'Opening Match', matchup: 'Mexico vs South Africa' },
      { date: 'Jun 17', round: 'Group K',       matchup: 'Uzbekistan vs Colombia' },
      { date: 'Jun 24', round: 'Group A',       matchup: 'Czechia vs Mexico' },
      { date: 'Jun 30', round: 'Round of 32',   matchup: null },
      { date: 'Jul 5',  round: 'Round of 16',   matchup: null },
    ],
  },
  {
    name: 'Estadio BBVA',
    city: 'Monterrey', country: 'Mexico', code: 'mx',
    capacity: 51348, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://en.wikipedia.org/wiki/Special:FilePath/Estadio_BBVA.jpg',
    description: 'Nestled at the base of the iconic Cerro de la Silla mountain, this 2015 stadium offers arguably the most breathtaking natural backdrop of any venue in the tournament.',
    fact: 'The stadium is built into the mountainside — some seats are actually carved into the hillside with the mountain as a natural wall behind them.',
    matches: [
      { date: 'Jun 14', round: 'Group F',     matchup: 'Sweden vs Tunisia' },
      { date: 'Jun 21', round: 'Group F',     matchup: 'Tunisia vs Japan' },
      { date: 'Jun 24', round: 'Group A',     matchup: 'South Africa vs South Korea' },
      { date: 'Jun 29', round: 'Round of 32', matchup: null },
    ],
  },
  {
    name: 'Estadio Akron',
    city: 'Guadalajara', country: 'Mexico', code: 'mx',
    capacity: 49850, role: 'Group Stage', roleTier: 'standard',
    img: 'https://upload.wikimedia.org/wikipedia/commons/8/8b/Estadio_Omnilife_Chivas.jpg',
    description: 'Home of Club Deportivo Guadalajara — "Chivas" — the only top-flight Mexican club that fields exclusively Mexican players. The city of Guadalajara is considered the cultural heart of Mexico.',
    fact: 'Guadalajara is the birthplace of mariachi music and tequila. The stadium sits in a city that defines Mexican culture.',
    matches: [
      { date: 'Jun 11', round: 'Group A', matchup: 'South Korea vs Czechia' },
      { date: 'Jun 18', round: 'Group A', matchup: 'Mexico vs South Korea' },
      { date: 'Jun 23', round: 'Group K', matchup: 'Colombia vs DR Congo' },
      { date: 'Jun 26', round: 'Group H', matchup: 'Uruguay vs Spain' },
    ],
  },
  // ── Canada ───────────────────────────────────────────────────────────────
  {
    name: 'BC Place',
    city: 'Vancouver', country: 'Canada', code: 'ca',
    capacity: 54500, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://en.wikipedia.org/wiki/Special:FilePath/BC_Place,_Vancouver_(2012)_-_03.JPG',
    description: "Canada's largest covered stadium features one of the world's largest air-supported retractable roofs. Previously hosted the 2015 Women's World Cup Final. The mountains surrounding Vancouver make this one of the most scenic host cities.",
    fact: 'The roof covers over 10 acres and can be opened or closed in about 20 minutes, inflated by a system that moves air at 100,000 cubic feet per minute.',
    matches: [
      { date: 'Jun 14', round: 'Group D',     matchup: 'Australia vs Türkiye' },
      { date: 'Jun 18', round: 'Group B',     matchup: 'Canada vs Qatar' },
      { date: 'Jun 24', round: 'Group B',     matchup: 'Switzerland vs Canada' },
      { date: 'Jun 26', round: 'Group G',     matchup: 'New Zealand vs Belgium' },
      { date: 'Jul 2',  round: 'Round of 32', matchup: null },
      { date: 'Jul 7',  round: 'Round of 16', matchup: null },
    ],
  },
  {
    name: 'BMO Field',
    city: 'Toronto', country: 'Canada', code: 'ca',
    capacity: 45000, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://en.wikipedia.org/wiki/Special:FilePath/BMO_Field,_Toronto,_Ontario_(29969149766).jpg',
    description: 'Home of Toronto FC and the Canadian national team in one of the most multicultural cities on Earth — Toronto is home to over 200 nationalities, making it a microcosm of the World Cup itself.',
    fact: 'Toronto is consistently ranked as one of the most diverse cities in the world, with over 200 languages spoken by its residents.',
    matches: [
      { date: 'Jun 12', round: 'Group B',     matchup: 'Canada vs Bosnia & Herz.' },
      { date: 'Jun 17', round: 'Group L',     matchup: 'Ghana vs Panama' },
      { date: 'Jun 20', round: 'Group E',     matchup: "Germany vs Côte d'Ivoire" },
      { date: 'Jun 23', round: 'Group L',     matchup: 'Panama vs Croatia' },
      { date: 'Jun 26', round: 'Group I',     matchup: 'Senegal vs Iraq' },
      { date: 'Jul 2',  round: 'Round of 32', matchup: null },
    ],
  },
  // ── United States ─────────────────────────────────────────────────────────
  {
    name: 'MetLife Stadium',
    city: 'East Rutherford, NJ', country: 'United States', code: 'us',
    capacity: 82500, role: '⭐ THE FINAL', roleTier: 'final',
    img: 'https://en.wikipedia.org/wiki/Special:FilePath/Metlife_stadium.jpg',
    description: 'Just 8 miles from midtown Manhattan, the largest stadium in the NFL will host the most watched sporting event on Earth. On July 19, 2026, the World Cup champion will be crowned here.',
    fact: 'On Final day, the stadium will be surrounded by the entire New York City metropolitan area — 20 million people within driving distance of the biggest match in football.',
    matches: [
      { date: 'Jun 13', round: 'Group C',     matchup: 'Brazil vs Morocco' },
      { date: 'Jun 16', round: 'Group I',     matchup: 'France vs Senegal' },
      { date: 'Jun 22', round: 'Group I',     matchup: 'Norway vs Senegal' },
      { date: 'Jun 25', round: 'Group E',     matchup: 'Ecuador vs Germany' },
      { date: 'Jun 27', round: 'Group L',     matchup: 'Panama vs England' },
      { date: 'Jun 30', round: 'Round of 32', matchup: null },
      { date: 'Jul 5',  round: 'Round of 16', matchup: null },
      { date: 'Jul 19', round: '🏆 FINAL',    matchup: null },
    ],
  },
  {
    name: 'AT&T Stadium',
    city: 'Arlington, TX', country: 'United States', code: 'us',
    capacity: 80000, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://upload.wikimedia.org/wikipedia/commons/2/2e/Cowboys_Stadium_2.jpg',
    description: "Known as 'Jerry World' after Dallas Cowboys owner Jerry Jones, this stadium is famous for its retractable roof and the world's largest high-definition video board — so big it has been hit by punted footballs.",
    fact: "The center-hung video board stretches 160 feet wide — longer than the width of the pitch — and has been accidentally struck by punted footballs during NFL games.",
    matches: [
      { date: 'Jun 14', round: 'Group F',     matchup: 'Netherlands vs Japan' },
      { date: 'Jun 17', round: 'Group L',     matchup: 'England vs Croatia' },
      { date: 'Jun 22', round: 'Group J',     matchup: 'Argentina vs Austria' },
      { date: 'Jun 25', round: 'Group F',     matchup: 'Japan vs Sweden' },
      { date: 'Jun 27', round: 'Group J',     matchup: 'Jordan vs Argentina' },
      { date: 'Jun 30', round: 'Round of 32', matchup: null },
      { date: 'Jul 6',  round: 'Round of 16', matchup: null },
      { date: 'Jul 14', round: 'Semifinal',   matchup: null },
    ],
  },
  {
    name: 'SoFi Stadium',
    city: 'Los Angeles, CA', country: 'United States', code: 'us',
    capacity: 70240, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://upload.wikimedia.org/wikipedia/commons/5/5e/So-Fi_Stadium_Exterior%2C_Los_Angeles.jpg',
    description: "The most expensive stadium ever built at $5.5 billion, home to the LA Rams and Chargers. Features a translucent roof, an indoor/outdoor design, and a 2.5-acre artificial lake that reflects the stadium's striking silhouette.",
    fact: 'At $5.5 billion in construction costs, it is the most expensive stadium ever built — nearly double the cost of any other stadium in history.',
    matches: [
      { date: 'Jun 12', round: 'Group D',     matchup: 'USA vs Paraguay' },
      { date: 'Jun 15', round: 'Group G',     matchup: 'Iran vs New Zealand' },
      { date: 'Jun 18', round: 'Group B',     matchup: 'Switzerland vs Bosnia & Herz.' },
      { date: 'Jun 21', round: 'Group G',     matchup: 'Belgium vs Iran' },
      { date: 'Jun 25', round: 'Group D',     matchup: 'Türkiye vs USA' },
      { date: 'Jun 28', round: 'Round of 32', matchup: null },
      { date: 'Jul 2',  round: 'Round of 32', matchup: null },
      { date: 'Jul 10', round: 'Quarterfinal', matchup: null },
    ],
  },
  {
    name: "Levi's Stadium",
    city: 'Santa Clara, CA', country: 'United States', code: 'us',
    capacity: 68500, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: "https://upload.wikimedia.org/wikipedia/commons/3/36/Levi%27s_Stadium_from_air.jpg",
    description: "Home of the San Francisco 49ers in the heart of Silicon Valley, this stadium is a showcase of technology — over 1,200 WiFi access points, a rooftop solar garden, and the most technologically advanced infrastructure of any venue.",
    fact: 'The stadium has a rooftop garden that grows actual plants, generates solar electricity, and recycles rainwater — the most environmentally advanced stadium in the World Cup.',
    matches: [
      { date: 'Jun 13', round: 'Group B',     matchup: 'Qatar vs Switzerland' },
      { date: 'Jun 17', round: 'Group J',     matchup: 'Austria vs Jordan' },
      { date: 'Jun 19', round: 'Group D',     matchup: 'Türkiye vs Paraguay' },
      { date: 'Jun 22', round: 'Group J',     matchup: 'Jordan vs Algeria' },
      { date: 'Jun 25', round: 'Group D',     matchup: 'Paraguay vs Australia' },
      { date: 'Jul 1',  round: 'Round of 32', matchup: null },
    ],
  },
  {
    name: 'Arrowhead Stadium',
    city: 'Kansas City, MO', country: 'United States', code: 'us',
    capacity: 76416, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://en.wikipedia.org/wiki/Special:FilePath/Arrowhead_Stadium_2010.JPG',
    description: 'Home of the Kansas City Chiefs and the Guinness World Record holder for loudest crowd roar in sports history. When 76,000 fans erupt in unison, the sound is physically felt through the concrete.',
    fact: 'In 2014 it set the Guinness World Record for loudest crowd noise at 142.2 decibels — louder than a jet engine at take-off.',
    matches: [
      { date: 'Jun 16', round: 'Group J',     matchup: 'Argentina vs Algeria' },
      { date: 'Jun 20', round: 'Group E',     matchup: 'Ecuador vs Curaçao' },
      { date: 'Jun 25', round: 'Group F',     matchup: 'Tunisia vs Netherlands' },
      { date: 'Jun 27', round: 'Group J',     matchup: 'Algeria vs Austria' },
      { date: 'Jul 3',  round: 'Round of 32', matchup: null },
      { date: 'Jul 11', round: 'Quarterfinal', matchup: null },
    ],
  },
  {
    name: 'Gillette Stadium',
    city: 'Foxborough, MA', country: 'United States', code: 'us',
    capacity: 65878, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://upload.wikimedia.org/wikipedia/commons/9/9c/Gillette_Stadium02.jpg',
    description: 'Situated between Boston and Providence, home of the New England Patriots. The Boston area is one of America\'s most storied sports markets, and Gillette Stadium sits in its proud center.',
    fact: 'The New England Revolution MLS team also calls Gillette home — meaning this stadium has genuine football heritage going into the World Cup.',
    matches: [
      { date: 'Jun 13', round: 'Group C',     matchup: 'Haiti vs Scotland' },
      { date: 'Jun 16', round: 'Group I',     matchup: 'Iraq vs Norway' },
      { date: 'Jun 19', round: 'Group C',     matchup: 'Scotland vs Morocco' },
      { date: 'Jun 23', round: 'Group L',     matchup: 'England vs Ghana' },
      { date: 'Jun 26', round: 'Group I',     matchup: 'Norway vs France' },
      { date: 'Jun 29', round: 'Round of 32', matchup: null },
      { date: 'Jul 9',  round: 'Quarterfinal', matchup: null },
    ],
  },
  {
    name: 'Lincoln Financial Field',
    city: 'Philadelphia, PA', country: 'United States', code: 'us',
    capacity: 69796, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://en.wikipedia.org/wiki/Special:FilePath/Lincoln_Financial_Field,_Philadelphia.jpg',
    description: "Home of the Philadelphia Eagles in one of America's most passionately sports-mad cities. Philadelphia Eagles fans are so legendarily intense that the team\'s stadium once had its own courtroom to handle fan disputes.",
    fact: "Philadelphia's stadium once had a working courtroom and jail cells beneath the stands to handle the notoriously rowdy fanbase — a detail that tells you everything about the city's sporting culture.",
    matches: [
      { date: 'Jun 14', round: 'Group E',     matchup: "Côte d'Ivoire vs Ecuador" },
      { date: 'Jun 19', round: 'Group C',     matchup: 'Brazil vs Haiti' },
      { date: 'Jun 22', round: 'Group I',     matchup: 'France vs Iraq' },
      { date: 'Jun 25', round: 'Group E',     matchup: "Curaçao vs Côte d'Ivoire" },
      { date: 'Jun 27', round: 'Group L',     matchup: 'Croatia vs Ghana' },
      { date: 'Jul 4',  round: 'Round of 16', matchup: null },
    ],
  },
  {
    name: 'Hard Rock Stadium',
    city: 'Miami Gardens, FL', country: 'United States', code: 'us',
    capacity: 64767, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Hard_Rock_Stadium_for_Super_Bowl_LIV_%2849606707583%29.jpg',
    description: "Home of the Miami Dolphins, recently transformed with a spectacular canopy roof. Miami's electric, multicultural atmosphere — a fusion of Latin American, Caribbean, and North American cultures — makes it one of the World Cup's most natural host cities.",
    fact: 'The 50,000 sq ft canopy roof provides shade for every seat, a critical feature given Miami averages 95°F in June. Players and fans alike will feel the difference.',
    matches: [
      { date: 'Jun 15', round: 'Group H',     matchup: 'Saudi Arabia vs Uruguay' },
      { date: 'Jun 21', round: 'Group H',     matchup: 'Uruguay vs Cape Verde' },
      { date: 'Jun 24', round: 'Group C',     matchup: 'Scotland vs Brazil' },
      { date: 'Jun 27', round: 'Group K',     matchup: 'Colombia vs Portugal' },
      { date: 'Jul 3',  round: 'Round of 32', matchup: null },
      { date: 'Jul 11', round: 'Quarterfinal', matchup: null },
      { date: 'Jul 18', round: '🥉 3rd Place', matchup: null },
    ],
  },
  {
    name: 'Lumen Field',
    city: 'Seattle, WA', country: 'United States', code: 'us',
    capacity: 72000, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://upload.wikimedia.org/wikipedia/commons/5/53/Qwest_Field_North.jpg',
    description: "Home of both the Seattle Seahawks NFL team and Seattle Sounders FC, Seattle boasts one of the strongest soccer cultures in America. The Sounders regularly lead MLS in attendance and have a supporter culture rivaling top European clubs.",
    fact: "Seattle Sounders fans fill 40,000 seats every home match and have a supporter section — the Emerald City Supporters — that never stops singing for 90 minutes.",
    matches: [
      { date: 'Jun 15', round: 'Group G',     matchup: 'Belgium vs Egypt' },
      { date: 'Jun 19', round: 'Group D',     matchup: 'USA vs Australia' },
      { date: 'Jun 24', round: 'Group B',     matchup: 'Bosnia & Herz. vs Qatar' },
      { date: 'Jun 26', round: 'Group G',     matchup: 'Egypt vs Iran' },
      { date: 'Jul 1',  round: 'Round of 32', matchup: null },
      { date: 'Jul 6',  round: 'Round of 16', matchup: null },
    ],
  },
  {
    name: 'Mercedes-Benz Stadium',
    city: 'Atlanta, GA', country: 'United States', code: 'us',
    capacity: 71000, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://en.wikipedia.org/wiki/Special:FilePath/Mercedes-Benz_Stadium,_Atlanta,_GA_(33597623348).jpg',
    description: "One of the most architecturally extraordinary buildings in sports, with a retractable roof that opens like a camera aperture — 8 triangular steel panels fold back to reveal the sky above. A genuine architectural landmark.",
    fact: "The roof opens like the iris of a camera — 8 steel petals peel back to reveal the sky. No other stadium in the world has anything like it.",
    matches: [
      { date: 'Jun 15', round: 'Group H',     matchup: 'Spain vs Cape Verde' },
      { date: 'Jun 18', round: 'Group A',     matchup: 'Czechia vs South Africa' },
      { date: 'Jun 21', round: 'Group H',     matchup: 'Spain vs Saudi Arabia' },
      { date: 'Jun 24', round: 'Group C',     matchup: 'Morocco vs Haiti' },
      { date: 'Jun 27', round: 'Group K',     matchup: 'DR Congo vs Uzbekistan' },
      { date: 'Jul 1',  round: 'Round of 32', matchup: null },
      { date: 'Jul 7',  round: 'Round of 16', matchup: null },
      { date: 'Jul 15', round: 'Semifinal',   matchup: null },
    ],
  },
  {
    name: 'NRG Stadium',
    city: 'Houston, TX', country: 'United States', code: 'us',
    capacity: 72220, role: 'Group Stage & Knockouts', roleTier: 'standard',
    img: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Reliantstadium.jpg',
    description: "The first NFL stadium with a retractable roof, in the most ethnically diverse major city in the United States. Houston speaks over 145 languages and has one of the largest Hispanic populations in the country — a city built for the World Cup.",
    fact: 'Houston is the most ethnically diverse major city in the United States, home to speakers of over 145 languages — a fitting reflection of the World Cup\'s global spirit.',
    matches: [
      { date: 'Jun 14', round: 'Group E',     matchup: 'Germany vs Curaçao' },
      { date: 'Jun 17', round: 'Group K',     matchup: 'Portugal vs DR Congo' },
      { date: 'Jun 23', round: 'Group K',     matchup: 'Portugal vs Uzbekistan' },
      { date: 'Jun 26', round: 'Group H',     matchup: 'Cape Verde vs Saudi Arabia' },
      { date: 'Jun 29', round: 'Round of 32', matchup: null },
      { date: 'Jul 4',  round: 'Round of 16', matchup: null },
    ],
  },
];

const COUNTRY_COLORS = {
  Mexico:        { from: '#006847', to: '#CE1126', text: '#fff' },
  Canada:        { from: '#D80621', to: '#8B0000', text: '#fff' },
  'United States': { from: '#0A3161', to: '#B31942', text: '#fff' },
};

const ROLE_BADGE = {
  final:   { bg: '#f0b429', color: '#0a1628', label: '⭐ THE FINAL' },
  special: { bg: '#7c3aed', color: '#fff',    label: 'Opening Match' },
  standard:{ bg: '#1a2f55', color: '#8899b8', label: '' },
};

const ROUND_COLOR = {
  'Opening Match': '#7c3aed',
  '🏆 FINAL':      '#f0b429',
  '🥉 3rd Place':  '#cd7f32',
  'Semifinal':     '#e53e3e',
  'Quarterfinal':  '#dd6b20',
  'Round of 16':   '#3182ce',
  'Round of 32':   '#2d3748',
  'Group Stage':   '#1a3550',
  'Group A': '#1a3550', 'Group B': '#1a3550', 'Group C': '#1a3550',
  'Group D': '#1a3550', 'Group E': '#1a3550', 'Group F': '#1a3550',
  'Group G': '#1a3550', 'Group H': '#1a3550', 'Group I': '#1a3550',
  'Group J': '#1a3550', 'Group K': '#1a3550', 'Group L': '#1a3550',
};

function CapacityBar({ capacity }) {
  const pct = Math.round((capacity / MAX_CAPACITY) * 100);
  return (
    <div style={{ marginTop: '0.5rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem', color: 'var(--text-muted)', marginBottom: '0.3rem' }}>
        <span>Capacity</span>
        <span style={{ fontWeight: 700, color: 'var(--text)' }}>{capacity.toLocaleString()}</span>
      </div>
      <div style={{ height: 6, background: 'var(--border)', borderRadius: 3, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${pct}%`, background: 'linear-gradient(90deg, var(--gold-dark), var(--gold))', borderRadius: 3, transition: 'width 0.8s ease' }} />
      </div>
    </div>
  );
}

function MatchSchedule({ matches }) {
  if (!matches || matches.length === 0) return null;
  return (
    <div style={{ borderTop: '1px solid var(--border)', paddingTop: '0.75rem', marginTop: '0.25rem' }}>
      <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.5rem' }}>
        📅 Match Schedule
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
        {matches.map((m, i) => {
          const roundColor = ROUND_COLOR[m.round] || '#1a3550';
          const isSpecial = m.round.includes('FINAL') || m.round.includes('3rd') || m.round === 'Opening Match' || m.round === 'Semifinal' || m.round === 'Quarterfinal';
          return (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.78rem' }}>
              <span style={{ color: 'var(--gold)', fontWeight: 700, minWidth: '3.2rem', fontSize: '0.72rem' }}>{m.date}</span>
              <span style={{
                background: roundColor,
                color: isSpecial ? '#fff' : 'var(--text-muted)',
                fontSize: '0.65rem', fontWeight: 700,
                padding: '0.15rem 0.45rem', borderRadius: 10,
                textTransform: 'uppercase', letterSpacing: '0.04em',
                whiteSpace: 'nowrap',
              }}>{m.round}</span>
              {m.matchup && (
                <span style={{ color: 'var(--text-muted)', fontSize: '0.72rem' }}>{m.matchup}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function Stadiums() {
  const [filter, setFilter] = useState('All');
  const [imgErrors, setImgErrors] = useState({});
  const countries = ['All', 'Mexico', 'Canada', 'United States'];

  const visible = filter === 'All' ? STADIUMS : STADIUMS.filter(s => s.country === filter);
  const sorted = [...visible].sort((a, b) => {
    if (a.roleTier === 'final') return -1;
    if (b.roleTier === 'final') return 1;
    if (a.roleTier === 'special') return -1;
    if (b.roleTier === 'special') return 1;
    return b.capacity - a.capacity;
  });

  const handleImgError = (name) => setImgErrors(prev => ({ ...prev, [name]: true }));

  return (
    <div>
      {/* Hero */}
      <div style={{
        background: 'linear-gradient(135deg, #0a1628 0%, #1a2f55 50%, #0a1628 100%)',
        borderRadius: 12, padding: '2.5rem 2rem', marginBottom: '2rem',
        border: '1px solid var(--border)', textAlign: 'center', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>🏟️</div>
        <h1 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: '0.4rem' }}>World Cup 2026 Stadiums</h1>
        <p style={{ color: 'var(--text-muted)', maxWidth: 560, margin: '0 auto', fontSize: '0.95rem' }}>
          16 iconic venues across Mexico, Canada, and the United States — from the historic Azteca to the futuristic Mercedes-Benz Stadium.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', marginTop: '1.2rem', fontSize: '0.85rem', color: 'var(--text-muted)' }}>
          <span>🇲🇽 3 venues</span>
          <span>🇨🇦 2 venues</span>
          <span>🇺🇸 11 venues</span>
          <span>👥 {(STADIUMS.reduce((s, v) => s + v.capacity, 0) / 1000).toFixed(0)}K total seats</span>
        </div>
      </div>

      {/* Filter tabs */}
      <div className="bracket-tabs" style={{ marginBottom: '1.5rem' }}>
        {countries.map(c => (
          <button key={c} className={`bracket-tab ${filter === c ? 'active' : ''}`} onClick={() => setFilter(c)}>
            {c === 'All' ? `All (${STADIUMS.length})` :
             c === 'Mexico' ? `🇲🇽 Mexico` :
             c === 'Canada' ? `🇨🇦 Canada` : `🇺🇸 United States`}
          </button>
        ))}
      </div>

      {/* Cards grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(340px, 100%), 1fr))', gap: '1.25rem' }}>
        {sorted.map(stadium => {
          const colors = COUNTRY_COLORS[stadium.country];
          const badge = ROLE_BADGE[stadium.roleTier];
          const imgFailed = imgErrors[stadium.name];
          return (
            <div key={stadium.name} className="card" style={{ padding: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column', transition: 'transform 0.15s, box-shadow 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.5)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
            >
              {/* Stadium photo */}
              {stadium.img && !imgFailed && (
                <div style={{ height: 170, overflow: 'hidden', flexShrink: 0 }}>
                  <img
                    src={stadium.img}
                    alt={stadium.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    onError={() => handleImgError(stadium.name)}
                  />
                </div>
              )}

              {/* Coloured header */}
              <div style={{
                background: `linear-gradient(135deg, ${colors.from}, ${colors.to})`,
                padding: '0.75rem 1.25rem',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                flexShrink: 0,
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                  <FlagIcon code={stadium.code} size="1.8em" />
                  <div>
                    <div style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{stadium.country}</div>
                    <div style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.9)', fontWeight: 600 }}>{stadium.city}</div>
                  </div>
                </div>
                {stadium.roleTier !== 'standard' && (
                  <span style={{ background: badge.bg, color: badge.color, fontSize: '0.7rem', fontWeight: 800, padding: '0.25rem 0.6rem', borderRadius: 20 }}>
                    {badge.label || stadium.role}
                  </span>
                )}
              </div>

              {/* Body */}
              <div style={{ padding: '1.25rem', flex: 1, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div>
                  <h2 style={{ fontSize: '1.1rem', fontWeight: 800, marginBottom: '0.15rem' }}>{stadium.name}</h2>
                  {stadium.roleTier === 'standard' && (
                    <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{stadium.role}</span>
                  )}
                </div>

                <CapacityBar capacity={stadium.capacity} />

                <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', lineHeight: 1.6, margin: 0 }}>
                  {stadium.description}
                </p>

                <div style={{
                  background: 'rgba(240,180,41,0.07)', border: '1px solid rgba(240,180,41,0.2)',
                  borderRadius: 8, padding: '0.65rem 0.85rem',
                  fontSize: '0.8rem', color: 'var(--text)', lineHeight: 1.5,
                }}>
                  <span style={{ color: 'var(--gold)', fontWeight: 700 }}>⚡ </span>{stadium.fact}
                </div>

                <MatchSchedule matches={stadium.matches} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
